import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import {LoadingScreenService} from '../../../services/loading-screen/loading-screen.service';
import {GlobalService} from '../../../global.service';
import { MessageService } from 'src/app/message.service';

@Component({
  selector: 'app-plan-change-confirmation',
  templateUrl: './plan-change-confirmation.component.html',
  styleUrls: ['./plan-change-confirmation.component.sass']
})
export class planChangeConfirmationComponent implements OnInit {
  @Input() nroOrder: boolean;
  @Input() planToChange;
  @Input() descriptions;
  @Input() numberOrder;
  @Input() pricePlan;
  @Output() updatescreenview = new EventEmitter<any>();
  @Output() updateInitializeData = new EventEmitter();

  constructor(private global: GlobalService, private loadingScreenService: LoadingScreenService, private router: Router, private messageService: MessageService) {
  }

  ngOnInit() {
    const payload = {
      message: 'Cambio de plan efectuado con éxtio',
      nroOrder: this.nroOrder ,
      descriptions: this.descriptions ,
      pricePlan: this.pricePlan ,
      planToChange: this.planToChange 
    }
    this.messageService.sentMessage('success', payload)
  }


  close() {
    this.updatescreenview.emit(1);
    this.updateInitializeData.emit();
    this.router.navigate(['/home'])
  }
}
